import Layout from "components/layout";
import { FortuneTellerNavigation } from "features/fortune-tellers/components/FortuneTellerNavigation";
import { GetStaticPaths, GetStaticProps } from "next";
import { NextSeo, NextSeoProps } from "next-seo";
import { ReactNode } from "react";
import { handleServerSideError } from "shared/utils/ssr";
import { MetaTag } from "utils/seo";
import getNextSeoProps from "utils/ssr/getNextSeoProps";
import { repository } from "repositories";
import { FortuneTellerDetailPresenter } from "features/fortune-tellers/components/Presenter";

interface Props {
  nextSeoProps: NextSeoProps;
}

const FortuneTellerDetail = ({ nextSeoProps }: Props) => {
  return (
    <>
      <NextSeo {...nextSeoProps} />
      <FortuneTellerDetailPresenter />
    </>
  );
};

FortuneTellerDetail.getLayout = (page: ReactNode) => {
  return <Layout nav={<FortuneTellerNavigation />}>{page}</Layout>;
};

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: [],
    fallback: "blocking",
  };
};

export const getStaticProps: GetStaticProps = async (ctx) => {
  const { params } = ctx;
  const { id } = params;

  try {
    const data = await repository.fortuneTeller.getMetaData(id).data();
    const { name } = data.fortuneTeller;

    const nextSeoProps = getNextSeoProps(ctx, {
      title: MetaTag.fortuneTellersListId.title(name),
      description: MetaTag.fortuneTellersListId.description(name),
      url: `https://miror.jp/fortune_tellers/list/${id}`,
      keywords: MetaTag.fortuneTellersListId.keywords(name),
      options: {
        openGraph: {
          images: [
            { url: data.fortuneTeller.imageUrl, width: 800, height: 600 },
            { url: data.fortuneTeller.thumbnailUrl, width: 800, height: 600 },
          ],
        },
      },
    });

    return {
      props: {
        nextSeoProps,
      },
    };
  } catch (error) {
    return handleServerSideError(error);
  }
};

export default FortuneTellerDetail;
